import { Amplify } from 'aws-amplify';

export const amplifyConfig = () => {
  Amplify.configure({
    Auth: {
      region: process.env.REACT_APP_COGNITO_AWS_REGION,
      identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    },
    API: {
      endpoints: [
        {
          name: process.env.REACT_APP_API_NAME,
          endpoint: process.env.REACT_APP_API_URL,
          region: process.env.REACT_APP_API_REGION,
        },
      ],
    },
  });
};
